<template>
  <div class="mainContain">
    <div class="box">
      <div class="ViewTitle">{{ title }}</div>
      <div class="contain gery">
        <el-form :label-position="labelPosition" label-width="110px" :model="form">
          <el-form-item label="区号">
            <el-select v-model="form.areaCode" placeholder="请选择区号">
              <el-option v-for="(item, index) in cityCode" :key="index"
                :label="`${item.displayMapping.zhCN} (+${item.areaCode})`" :value="+item.areaCode">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 当 gptsUserPhone 为 null 时的简单表单 -->
          <template v-if="!gptsUserPhone || gptsUserPhone === 'null'">
           <el-form-item label="手机号">
              <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="验证码" class="codeBox">
              <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
              <el-button type="text" :disabled="codeDisabled" class="setCode" @click="getoriginalCode()">{{ codeBtnText
                }}</el-button>
            </el-form-item>
          </template>

          <!-- 当 gptsUserPhone 不为 null 时的完整表单 -->
          <template v-else>
                <el-form-item label="原先手机号">
              <el-input v-model="gptsUserPhone" disabled></el-input>
            </el-form-item>
            <el-form-item label="验证码" class="codeBox">
              <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
              <el-button type="text" :disabled="oldCodeDisabled" class="setCode" @click="getoldCode()">{{ oldCodeBtnText
                }}</el-button>
            </el-form-item>
            <el-form-item label="新手机号">
              <el-input v-model="form.newphone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="验证码" class="codeBox">
              <el-input v-model="form.newcode" placeholder="请输入验证码"></el-input>
              <el-button type="text" :disabled="newCodeDisabled" class="setCode" @click="getnewCode()">{{ newCodeBtnText
                }}</el-button>
            </el-form-item>
          </template>

          <div class="submit" style="display: flex; justify-content: flex-end;margin-right: 5vh">
            <el-button class="cancleStyle" @click="cancleSubmit()">取消</el-button>
            <el-button class="confirmStyle" @click="submitnew()">完成</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <div class="islider" v-if="show">
      <bc-slider @validImg="validImg" @close="onClose" :backgroupImg="backgroupImg" :moveImg="moveImg"
        :log="true"></bc-slider>
      <!--
        @getImg="getImg" -->
    </div>
  </div>
</template>
<script>
import bcSlider from "@/components/slider";
import { smsSend, captcha, captchaVerify, bindPhone } from "@/api/user";
import { shareUrl } from "@/utils/vxshare.js";
import {getsms, changePhone, bindPhone1} from "@/api/login";
export default {
  name: "ChangePhone",
  components: { bcSlider },
  data() {
    return {
      changeVisable:1,
      title: "修改手机号",
      titleEn: "Modify mobile phone number",
      labelPosition: "right",
      form: {
        areaCode: "",
        phone: "",
        newphone:"",
        code: "",
        newcode: "",
        userId: "",
      },
          // 旧手机号验证码相关
      codeBtnText: '获取验证码',
      oldCodeDisabled: false,
      oldCodeBtnText: '获取验证码',
      oldCodeCountdown: 0,
      oldCodeTimer: null,
      // 新手机号验证码相关
      newCodeDisabled: false,
      newCodeBtnText: '获取验证码',
      newCodeCountdown: 0,
      newCodeTimer: null,

      backToken: "",
      mobile: "",
      backgroupImg: "",
      moveImg: "",
      secretKey: "",
      show: false,
      gptsUserPhone: localStorage.getItem("gptsUserPhone"),
      // gptsUserPhone: null,
      userId: localStorage.getItem("gptsUserId"),
      token: localStorage.getItem("token"),
      cityCode: [
        // 亚洲
        { areaCode: "86", displayMapping: { zhCN: "中国", enUS: "China" } },
        { areaCode: "852", displayMapping: { zhCN: "中国香港", enUS: "Hong Kong" } },
        { areaCode: "853", displayMapping: { zhCN: "中国澳门", enUS: "Macao" } },
        { areaCode: "886", displayMapping: { zhCN: "中国台湾", enUS: "Taiwan" } },
        { areaCode: "81", displayMapping: { zhCN: "日本", enUS: "Japan" } },
        { areaCode: "82", displayMapping: { zhCN: "韩国", enUS: "South Korea" } },
        { areaCode: "65", displayMapping: { zhCN: "新加坡", enUS: "Singapore" } },
        { areaCode: "60", displayMapping: { zhCN: "马来西亚", enUS: "Malaysia" } },
        { areaCode: "63", displayMapping: { zhCN: "菲律宾", enUS: "Philippines" } },
        { areaCode: "66", displayMapping: { zhCN: "泰国", enUS: "Thailand" } },
        { areaCode: "84", displayMapping: { zhCN: "越南", enUS: "Vietnam" } },
        { areaCode: "91", displayMapping: { zhCN: "印度", enUS: "India" } },

        // 欧洲
        { areaCode: "44", displayMapping: { zhCN: "英国", enUS: "UK" } },
        { areaCode: "33", displayMapping: { zhCN: "法国", enUS: "France" } },
        { areaCode: "49", displayMapping: { zhCN: "德国", enUS: "Germany" } },
        { areaCode: "7", displayMapping: { zhCN: "俄罗斯", enUS: "Russia" } },
        { areaCode: "39", displayMapping: { zhCN: "意大利", enUS: "Italy" } },
        { areaCode: "34", displayMapping: { zhCN: "西班牙", enUS: "Spain" } },

        // 北美
        { areaCode: "1", displayMapping: { zhCN: "美国/加拿大", enUS: "USA/Canada" } },
        { areaCode: "52", displayMapping: { zhCN: "墨西哥", enUS: "Mexico" } },

        // 南美
        { areaCode: "55", displayMapping: { zhCN: "巴西", enUS: "Brazil" } },
        { areaCode: "54", displayMapping: { zhCN: "阿根廷", enUS: "Argentina" } },

        // 大洋洲
        { areaCode: "61", displayMapping: { zhCN: "澳大利亚", enUS: "Australia" } },
        { areaCode: "64", displayMapping: { zhCN: "新西兰", enUS: "New Zealand" } },

        // 中东
        { areaCode: "971", displayMapping: { zhCN: "阿联酋", enUS: "UAE" } },
        { areaCode: "966", displayMapping: { zhCN: "沙特", enUS: "Saudi Arabia" } },

        // 非洲
        { areaCode: "27", displayMapping: { zhCN: "南非", enUS: "South Africa" } },
        { areaCode: "20", displayMapping: { zhCN: "埃及", enUS: "Egypt" } }
      ],
      disabled: false,
      setCode: "发送验证码",
      setCodeEn: "Verification code",
      languageSelect: "",
    };
  },
  watch: {
        // gptsUserPhone: localStorage.getItem("gptsUserPhone"),
    // "$store.state.cityCode"(newValue) {
    //   this.cityCode = newValue;
    // },
  },
  computed: {},
  created() {
    console.log("this.gptsUserPhone", this.gptsUserPhone);
    console.log(typeof localStorage.getItem("gptsUserPhone")); // 输出: "string"
    // this.cityCode = this.$store.state.cityCode;
    if (localStorage.getItem("language")) {
      this.languageSelect = localStorage.getItem("language");
    } else {
      this.languageSelect = "zh";
    }
    let type = this.$route.query.type;
    this.title = type == 1 ? "修改手机号" : "绑定手机号";
    this.getImg();
    let url = window.location.host;
    // let url = 'https://oilgasinfoai.com/?language=zh'
    setTimeout(() => {
      //encodeURIComponent 将你的URL进行转译一下，因为微信分享出去后会带有多余用不到的参数
      let shareData = {
        url: url,
        title: "油气人才",
        text: "洞悉油气行业变化，体验AI大模型，就来油气人才！",
      };
      shareUrl(shareData);
    }, 1000);
  },
  methods: {
    changeheadVisable(){
      if(this.changeVisable===1){
        this.changeVisable=0
      }
      else{
        this.changeVisable=1
      }
      console.log("父组件", this.changeVisable)
    },
    onClose() {
      this.show = false;
      this.getImg();
    },
    // callback
    // 获取滑动验证码（下方有格式截图）
    getImg() {
      // this.$axios
      //   .post("https://oilgasmall.eccode.net/idaasCaptcha")
      captcha().then((res) => {
        this.backToken = res.data.token;
        this.secretKey = res.data.secretKey;
        this.backgroupImg = res.data.originalImageBase64;
        this.moveImg = res.data.jigsawImageBase64;
        // callback(res.data);
      });
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(moveX, fn) {
      // moveX为小滑块滑动的距离
      // 330为背景图的宽度，可设置为动态变量，310是偏移量
      const moveLeftDistance = (moveX * 310) / parseInt(330);
      const data = {
        pointJson: JSON.stringify({ x: moveLeftDistance, y: 5.0 }),
        token: this.backToken,
        type: 1,
        phone: this.form.phone,
        areaCode: this.form.areaCode,
        // sender: this.form.phone,
      };
      captchaVerify(data)
        .then((res) => {
          const result = res;
          console.log(res.data);
          if (result.data) {
            this.onClose();
            // 调用登录的请求方法
            let data = {
              phone: this.form.phone,
              areaCode: this.form.areaCode,
              captchaToken: res.data,
              event:
                this.title == "修改手机号"
                  ? "UPDATE_MOBILE_SMS"
                  : "UPDATE_MOBILE_SMS",
            };
            smsSend(data).then((respon) => {
              if (!respon.data.data) {
                this.$message({
                  message: respon.msg,
                  type: "success",
                });
                this.tackBtn(); //验证码倒数60秒
              } else {
                console.log(respon.data);
                let data1 = JSON.parse(respon.data.data);
                this.$message({
                  message: data1.error_msg,
                  type: "error",
                });
              }
            });
          } else {
            fn(false);
          }
        })
        .catch(() => {
          fn(false);
        });
      this.show = true;
    },
    // 获取新用户绑定手机号的验证码
getoriginalCode() {
  if (!this.validatePhone(this.form.phone)) {
    return;
  }
  this.startOriginalCodeCountdown();
  this.sendSmsCode(this.form.phone, 'original');
},

// 新用户验证码倒计时
startOriginalCodeCountdown() {
  this.codeDisabled = true;
  let countdown = 60;
  this.codeBtnText = `${countdown}秒后重新获取`;
  
  const timer = setInterval(() => {
    countdown--;
    this.codeBtnText = `${countdown}秒后重新获取`;
    
    if (countdown <= 0) {
      clearInterval(timer);
      this.codeDisabled = false;
      this.codeBtnText = '获取验证码';
    }
  }, 1000);
},

      // 获取旧手机验证码
    getoldCode() {
      if (!this.validatePhone(this.gptsUserPhone)) {
        return;
      }
      this.startOldCodeCountdown();
      this.sendSmsCode(this.gptsUserPhone, 'old');
    },
    
    // 获取新手机验证码
    getnewCode() {
      if (!this.validatePhone(this.form.newphone)) {
        return;
      }
      this.startNewCodeCountdown();
      this.sendSmsCode(this.form.newphone, 'new');
    },
    
    // 手机号验证
    validatePhone(phone) {
      if (!this.form.areaCode) {
        this.$message.error("请选择区号");
        return false;
      }
      if (!phone) {
        this.$message.error("请输入手机号");
        return false;
      }
      const reg = /^[1][3-9]\d{9}$/;
      if (!reg.test(phone)) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
      return true;
    },
    
    // 发送短信验证码
    sendSmsCode(phone, type) {
      getsms({ 
        phone: phone,
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('验证码发送成功');
        } else {
          this.$message.error(res.msg || '验证码发送失败');
          // 发送失败时重置对应按钮状态
          if (type === 'original') {
            this.codeDisabled = false;
            this.codeBtnText = '获取验证码';
          } else if (type === 'old') {
            clearInterval(this.oldCodeTimer);
            this.oldCodeDisabled = false;
            this.oldCodeBtnText = '获取验证码';
          } else {
            clearInterval(this.newCodeTimer);
            this.newCodeDisabled = false;
            this.newCodeBtnText = '获取验证码';
          }
        }
      }).catch(() => {
        this.$message.error('请求失败，请重试');
      });
    },
    
    // 旧手机号倒计时
    startOldCodeCountdown() {
      this.oldCodeDisabled = true;
      this.oldCodeCountdown = 60;
      this.oldCodeBtnText = `${this.oldCodeCountdown}秒后重新获取`;
      
      this.oldCodeTimer = setInterval(() => {
        this.oldCodeCountdown--;
        this.oldCodeBtnText = `${this.oldCodeCountdown}秒后重新获取`;
        
        if (this.oldCodeCountdown <= 0) {
          clearInterval(this.oldCodeTimer);
          this.oldCodeDisabled = false;
          this.oldCodeBtnText = '获取验证码';
        }
      }, 1000);
    },
    
    // 新手机号倒计时
    startNewCodeCountdown() {
      this.newCodeDisabled = true;
      this.newCodeCountdown = 60;
      this.newCodeBtnText = `${this.newCodeCountdown}秒后重新获取`;
      
      this.newCodeTimer = setInterval(() => {
        this.newCodeCountdown--;
        this.newCodeBtnText = `${this.newCodeCountdown}秒后重新获取`;
        
        if (this.newCodeCountdown <= 0) {
          clearInterval(this.newCodeTimer);
          this.newCodeDisabled = false;
          this.newCodeBtnText = '获取验证码';
        }
      }, 1000);
    },
  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.oldCodeTimer);
    clearInterval(this.newCodeTimer);
  },
   //提交验证码的新方法
    submitnew() {
          const reg = /^\d{6,13}$/;
      if (!this.form.areaCode) {
        this.$message.error("请选择区号");
        return false;
      }
      // if (!this.form.newphone) {
      //   this.$message.error("请输入手机号");
      //   return false;
      // }
      // if (!reg.test(this.form.newphone)) {
      //   this.$message.error("请输入正确的手机号");
      //   return false;
      // }
      // if (!this.form.code) {
      //   this.$message.error("请输入验证码");
      //   return false;
      // }
      // if (!this.form.newcode) {
      //   this.$message.error("请输入验证码");
      //   return false;
      // }
       // 新用户绑定逻辑
  if (!this.gptsUserPhone || this.gptsUserPhone === 'null') {
    if (!this.form.phone) {
      this.$message.error("请输入手机号");
      return false;
    }
    if (!reg.test(this.form.phone)) {
      this.$message.error("请输入正确的手机号");
      return false;
    }
    if (!this.form.code) {
      this.$message.error("请输入验证码");
      return false;
    }
     // 调用 bindPhone 接口
    bindPhone1({
      gptsUserPhone: this.form.phone,
      areaCode: this.form.areaCode,
      code: this.form.code,
      gptsUserId: this.userId,
    }).then((res) => {
      if (res.code === 200) {
        this.$message.success("绑定成功");
        this.$router.push("/secure")
        // localStorage.setItem('gptsUserPhone', this.form.phone);
        // window.location.reload();
      } else {
        this.$message.error(res.msg || "绑定失败");
      }
    });

  } else {
    if (!this.form.newphone) {
      this.$message.error("请输入新手机号");
      return false;
    }
    if (!reg.test(this.form.newphone)) {
      this.$message.error("请输入正确的新手机号");
      return false;
    }
    if (!this.form.code || !this.form.newcode) {
      this.$message.error("请输入验证码");
      return false;
    }
    changePhone(
      {gptsUserId:this.userId,
      newPhone:this.form.newphone,
      oldCode:this.form.code,
      newCode:this.form.newcode,
      oldPhone:this.gptsUserPhone,
      areaCode:this.form.areaCode,
    }).then((res) => {
      if (res.code === 200) {
        this.$message.success("修改成功");
        // 成功后更新显示的手机号
        this.currentPhone = this.form.newphone;
        // 更新本地存储
        localStorage.setItem('gptsUserPhone', this.currentPhone);
         window.location.reload(true);
      }else {
          this.$message.error(res.msg || "修改失败");
          // 失败时保持原手机号显示
        }
    })
    }
  },
    //获取验证码 并只验证手机号 是否正确(原先代码)
    getCode() {
      if (!this.form.areaCode) {
        this.$message.error("请选择区号");
        return false;
      }
      if (!this.form.newphone) {
        this.$message.error("请输入手机号");
        return false;
      }
      // 一个简单的手机号正则表达式，仅包括数字，长度为11位
      var reg = /^[1][3-9]\d{9}$/;

      if (!reg.test(this.form.newphone)) {
        this.$message.error("请输入正确的手机号");
        return false;
      }

      this.show = true;
    },
    tackBtn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.setCode = "获取验证码";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.setCode = time + "秒后重试";
          time--;
        }
      }, 1000);
    },
    cancleSubmit(){
      this.$router.push("/secure")
    },
    submit() {
      // eslint-disable-next-line no-unreachable
      const reg = /^\d{6,13}$/;
      if (!this.form.areaCode) {
        this.$message.error("请选择区号");
        return false;
      }
      if (!this.form.phone) {
        this.$message.error("请输入手机号");
        return false;
      }
      if (!reg.test(this.form.phone)) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
      if (!this.form.code) {
        this.$message.error("请输入验证码");
        return false;
      }
      this.form.token = localStorage.getItem("Zyaccess_token"); // 竹云token
      this.form.language = this.languageSelect;
      bindPhone(this.form).then(() => {
        this.$message({
          message: "修改成功！", //提示的信息
          type: "success", //类型是成功
          duration: 1200, //显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
          onClose: () => {
            location.reload();
            this.getUserCom();
            this.$router.go(-1);
          },
        });
      });
    },
    getCodeEn() {
      const reg = /^\d{6,13}$/;
      if (!this.form.areaCode) {
        this.$message.error("Please select an area code");
        return false;
      }
      if (!this.form.phone) {
        this.$message.error("Please enter your phone number");
        return false;
      }
      if (!reg.test(this.form.phone)) {
        this.$message.error("Please enter the correct phone number");
        return false;
      }
      this.show = true;
    },
    tackBtnEn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.setCodeEn = "Verification code";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.setCodeEn = "Try again in" + time + " secondS";
          time--;
        }
      }, 1000);
    },
    submitEn() {
      // eslint-disable-next-line no-unreachable
      const reg = /^\d{6,13}$/;
      if (!this.form.areaCode) {
        this.$message.error("Please select an area code");
        return false;
      }
      if (!this.form.phone) {
        this.$message.error("Please enter your phone number");
        return false;
      }
      if (!reg.test(this.form.phone)) {
        this.$message.error("Please enter the correct phone number");
        return false;
      }
      if (!this.form.code) {
        this.$message.error("Please enter the verification code");
        return false;
      }
      this.form.token = localStorage.getItem("Zyaccess_token"); // 竹云token
      this.form.language = this.languageSelect;
      bindPhone(this.form).then(() => {
        this.$message({
          message: "Modified successfully！", //提示的信息
          type: "success", //类型是成功
          duration: 1200, //显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
          onClose: () => {
            this.getUserCom();
            this.$router.go(-1);
          },
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.mainContain {
  width: 65vw;
  border-radius: 9px;
  margin: 0 1vw;
  height: 75vh;
  padding: 0 2vw 3vh 0;
  position: relative;
  background-image: url("../../assets/oilba.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  .box {
    padding: 2vh 0;
    border-radius: 9px;
    background: #fff;

    .ViewTitle {
      height: 8vh;
      line-height: 8vh;
      border-bottom: 1px solid #ebebeb;
      font-size: 1vw;
      color: #333333;
      font-weight: 400;
      padding: 0 3vw;
    }

    .contain {
      padding: 8vh 3vw;
      width: fit-content;

      .el-form-item {
        font-size: 0.9vw;
        margin-bottom: 3vh;
      }

      .submit {
        width: 7vw;
        height: 6vh;
        line-height: 6vh;
        text-align: center;
        border-radius: 9px;
        position: absolute;
        bottom:5vh;
        right:5vw;
        color: #ffffff;
        cursor: pointer;

      }
      .cancleStyle {
        margin-top: 1vh;
        width: fit-content;
        padding: 0 3vw;
        height: 6vh;
        border-radius: 9px;
        opacity: 1;
        border: 1px solid #bf0022;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-family: arial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #bf0022;
        line-height: 20px;
        -webkit-background-clip: text;
      }
      .confirmStyle {
        margin-top: 1vh;
        width: fit-content;
        padding: 0 3vw;
        height: 6vh;
        border-radius: 9px;
        margin-left: 2vw;
        cursor: pointer;
        border: none;
        background-color: #bf0022;
        font-size: 16px;
        font-family: arial, sans-serif, "Microsoft Yahei";
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        ::v-deep .el-button{
          width: 10vw!important;
        }
      }
    }
  }

}

::v-deep .el-input__prefix {
  left: 90%;
  transition: all 0.3s;
}
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: white !important;
  border: #575757 1px solid !important;
  //color: #c0c4cc;
  cursor: not-allowed;
}

::v-deep .el-input .el-input__inner {
  background-color: white !important;
  border: #575757 1px solid !important;
  //color: #c0c4cc;
  height: 6vh;
}

::v-deep {
  .el-input__inner {
    height: 48px;
  }

  .el-form-item__label {
    color: #666;
    font-size: 16px;
    // padding-right: 32px;
    line-height: 48px;
  }
  .codeBox {
    .el-form-item__content {
      display: flex;
      .el-input {
        flex: 1;
      }
      .setCode {
        width: 120px;
        height: 48px;
        // line-height: 50px;
        text-align: center;
        border-radius: 4px;
        background: var(--main-color);
        color: #fff;
        font-size: 14px;
        margin-left: 15px;
      }
    }
  }
}
</style>
